import { gql } from '@apollo/client/core';

export const deleteNoteEntry = gql`
  mutation deleteNoteEntry($id: String) {
    deleteNoteEntry(id: $id)
  }
`;
